import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Form } from "./Form";
import { ReservationFormPage } from "./FormComponents/ReservationFormPage/ReservationFormPage";
import { MembershipForm } from "./FormComponents/MembershipForm/MembershipForm";
import { getAuthenticated } from "utils/functions";
export const FormLinkRouting = () => {
  const isAuthenticated = getAuthenticated();
  const isAuth =
    localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;

  const { formOnlineData } = useSelector((state) => state?.Forms);

  const hasFormData = formOnlineData && Object.keys(formOnlineData).length > 0;
  const isReservedNotAllowed = hasFormData && !formOnlineData?.allowNonMembers && !isAuth;
  const formId = formOnlineData?._id || localStorage.getItem("currentFormId");

  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path="/form/:id/reservation"
          render={({ match }) =>
            isReservedNotAllowed ? (
              <Redirect to={`/form/${formId || match.params.id}`} />
            ) : (
              <ReservationFormPage />
            )
          }
        />
        <Route
          exact
          path="/form/:id"
          render={({ match }) => {
            localStorage.setItem("currentFormId", match.params.id);
            return <Form />;
          }}
        />
        <Route exact path="/membership-form/:id" component={MembershipForm} />
      </Switch>
    </BrowserRouter>
  );
};
